var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vx-card", [
    _c("iframe", {
      attrs: {
        title: "KPIs LatinAD",
        width: "100%",
        height: "800",
        src: "https://v0-latinad-okrs.vercel.app/",
        frameborder: "0",
        allowfullscreen: "true",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }